/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Delete from './Delete/index'
import Description from './Description/index'
import Edit from './Edit/index'
import Icons from './Icons/index'
import Number from './Number/index'
import React from 'react'
import Related from './Related/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/Phones/Content/Phone"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Phone.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
<div
  data-testid="Phone.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Icons
  viewPath={`${viewPath}/Icons`}
/>
<div
  data-testid="Phone.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Related
  viewPath={`${viewPath}/Related`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}